module.exports = __webpack_public_path__ + "static/img/huoqushouquan.cceeb5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/huoqushouquan.png
// module id = oEY/
// module chunks = 31